/*global angular */
/*jslint node: true */

'use strict';

// todo / improvements:
// * put embedded templates into its own files (videobackground.html & videobackground_config.html)
// * play video if users scrolls to the section
//   example: section is out of view and user scrolls to it, autoplay is not useful in this case
// * pause video if users scrolls down and the section with videobackground is out of view

var videobackground = angular.module('msVideobackground', []);

videobackground.filter('trustUrl', ['$sce', function ($sce) {
    return function (recordingUrl) {
        return $sce.trustAsResourceUrl(recordingUrl);
    };
}]);

videobackground.service('msVideobackground', ['$compile', function ($compile) {
    var section, sectionElement;

    var template = '<div ' +
        '   class="msVideobackground" ' +
        '   style="position: absolute;top: 0;left: 0;width: 100%;height: 100%"' +
        '>' +

        // for youtube videos
        '<iframe ' +
        '   ng-if="section.settings.msVideobackground.yt_video_id" ' +
        '   frameborder="0" height="100%" width="100%" muted="muted" ' +
        '   ng-src="{{(\'https://www.youtube.com/embed/\' + section.settings.msVideobackground.yt_video_id + \'?' +
        'autoplay=1' +
        // loop works only in combination with playlist parameter, playlist parameter value is the video id
        '&loop=\' + (section.settings.msVideobackground.loop ? 1 : 0) + \'' +
        '&playlist=\' + (section.settings.msVideobackground.loop ? section.settings.msVideobackground.yt_video_id : null) + \'' +
        '&controls=0' +
        '&wmode=opaque' +
        '&showinfo=0' + // do not show infos about video or uploader
        '&autohide=1' +
        '&disablekb=1' + // disable keyboard input
        '&modestbranding=0' + // do not show yt logo
        '&rel=0' + // do not show related videos
        '&vq=\' + section.settings.msVideobackground.yt_vq' +
        ') | trustUrl}}"' +
        '>' +
        '</iframe>' +

        // video files
        '<video ' +
        '   ng-if="section.settings.msExt.msVideobackground && (section.settings.msVideobackground.video1 || section.settings.msVideobackground.image)" ' +
        '   ng-attr-autoplay="{{section.settings.msVideobackground.autoplay || undefined }}"' +
        '   ng-attr-loop="{{section.settings.msVideobackground.loop || undefined }}"' +
        '   poster="{{section.settings.msVideobackground.image | trustUrl }}"' +
        '   muted="muted"' +
        '   style="width:100%;, height:100%;, object-fit:cover;" ' +
        '>' +
        '   <source ng-if="section.settings.msVideobackground.video1 | trustUrl" ng-src="{{section.settings.msVideobackground.video1 | trustUrl}}" type="video/webm">' +
        '   <source ng-if="section.settings.msVideobackground.video2 | trustUrl" ng-src="{{section.settings.msVideobackground.video2 | trustUrl}}" type="video/mp4">' +
        '</video>' +

        '</div>';

    var msVideobackground = {
        /* define methods here that should be available in template,
           e.g. <md-button ng-click="msVideobackground.doSomething(...)"></md-button>
        doSomething: function (param1, param2) {
        } */

        timer: null,

        addToParseQueue: function(uri) {
            clearTimeout(this.timer);
            this.timer = setTimeout(this.parseVideoIdFromUrl, 500);
        },
        parseVideoIdFromUrl: function() {
            var url = section.settings.msVideobackground.yt_video_url;
            var video_id = url.split('v=')[1];
            var ampersandPosition = video_id.indexOf('&');
            if (ampersandPosition != -1) {
                video_id = video_id.substring(0, ampersandPosition);
            }
            section.settings.msVideobackground.yt_video_id = video_id;
        }
    };

    return {
        injectDirective: function (scope, _element) {
            sectionElement = _element[0]; // sectionElement.children[0] = container
            section = scope.section;

            // create default config
            if (!section.settings) section.settings = {};
            if (!section.settings.msExt) section.settings.msExt = {};
            if (!section.settings.msExt.msVideobackground) section.settings.msExt.msVideobackground = false;
            // default config for this extension
            if (!section.settings.msVideobackground) {
                section.settings.msVideobackground = {
                    'autoplay': true,
                    'loop': true,
                    'video1': '',
                    'video2': '',
                    'image': '',
                    'yt_video_id': '',
                    'yt_video_url': '',
                    'yt_vq': 'medium'
                };
            }

            // render extension template
            var linkFn = $compile(template);
            var insertedElement = linkFn(scope);

            // prepend rendered extension template to the section
            angular.element(sectionElement).prepend(insertedElement);

            // loop was disabled and video ended - loop activated, so replay video
            var loopWatch = scope.$watch('section.settings.msVideobackground.loop', function (newValue, oldValue) {
                if (newValue && !oldValue) {
                    var video = sectionElement.querySelector('video');
                    video.play();
                }
            });

            var youtubeUrlToVideoIdWatch = scope.$watch('section.settings.msVideobackground.yt_video_url', function (newValue) {
                if (newValue !== '') {
                    section.settings.msVideobackground.video1 = '';
                    msVideobackground.addToParseQueue(newValue);
                } else {
                    // reset video id
                    section.settings.msVideobackground.yt_video_id = '';
                }
            });

            var videoWatch = scope.$watch('section.settings.msVideobackground.video1', function(newValue) {
                if (newValue !== '') {
                    section.settings.msVideobackground.yt_video_url = '';
                }
            });

            // clean up when video background is disabled
            var destroyWatch = scope.$watch('section.settings.msExt.msVideobackground', function (enabled) {
                if (!enabled) {
                    insertedElement.remove();
                    loopWatch();
                    youtubeUrlToVideoIdWatch();
                    videoWatch();
                    destroyWatch();
                }
            });
        },
        config: {
            type: ['section'],
            title: 'Videobackground',
            extendConfig: 'section-background',
            visible: function (context_type) {
                return context_type == 'section';
            },
            template:
                '<md-switch ng-model="subject.settings.msExt.msVideobackground">Videobackground</md-switch>' +
                '<md-switch ng-show="subject.settings.msExt.msVideobackground" ng-model="subject.settings.msVideobackground.loop">Schleife</md-switch>' +

                '<md-tabs ng-show="subject.settings.msExt.msVideobackground" md-selected="0" md-dynamic-height md-align-tabs="top" ng-cloak>' +
                    // youtube
                '    <md-tab>' +
                '        <md-tab-label>YouTube</md-tab-label>' +
                '        <md-tab-body>' +

                '           <md-input-container flex>' +
                '              <label>YouTube-Video URL</label>' +
                '              <input ng-model="subject.settings.msVideobackground.yt_video_url">' +
                '           </md-input-container>' +

                '           <md-input-container>' +
                '               <label>State</label>' +
                '               <md-select ng-model="subject.settings.msVideobackground.yt_vq">' +
                '                   <md-option value="tiny">144p</md-option>' +
                '                   <md-option value="small">240p</md-option>' +
                '                   <md-option value="medium">360p (empfohlen)</md-option>' +
                '                   <md-option value="large">480p</md-option>' +
                '                   <md-option value="hd720">720p</md-option>' +
                '                   <md-option value="hd1080">1080p</md-option>' +
                '               </md-select>' +
                '           </md-input-container>' +

                '        </md-tab-body>' +
                '    </md-tab>' +

                    // video file
                '    <md-tab>' +
                '       <md-tab-label>Eigenes Video</md-tab-label>' +
                '        <md-tab-body>' +
                '           <md-input-container flex>' +
                '              <label>Video URL</label>' +
                '              <input ng-model="subject.settings.msVideobackground.video1">' +
                '           </md-input-container>' +
                '           <md-input-container flex><label>Fallback Video URL</label><input ng-model="subject.settings.msVideobackground.video2"></md-input-container>' +
                '           <md-input-container flex><label>Fallback Image URL</label><input ng-model="subject.settings.msVideobackground.image"></md-input-container>' +
                '        </md-tab-body>' +
                '    </md-tab>' +
                '</md-tabs>'
        },
        init: function (scope, context_element) {
            // inject msVideobackground object into the main scope to be accessible in template
            scope.msVideobackground = msVideobackground;
        }
    };
}]);
